<div *ngIf="form">
  <div class="flex-row align-center mat-h2 gap-sm">
    E-Post
  </div>

  <mat-divider/>

  <h4 class="mat-headline-6 info" [class.active]="form.get('active').value === true"
      [class.inactive]="!form.get('active').value">
    <mat-icon [svgIcon]="isActive()? EsvgFiles.correct : EsvgFiles.error"/>
    <span>E-Post ist {{ form.get('active').value === true ? 'aktiv' : 'inaktiv' }}!</span>
  </h4>

  <kpi4me-text-element [formControlElement]="form.controls.ekpNumber" [data]="epkText"/>

  <div class="mat-h3" style="padding-top: 1rem">
    <span> Einstellungen für den Druckvorgang </span>

    <mat-divider/>
  </div>

  <kpi4me-checkbox-element [formControlElement]="form.controls.duplex" [data]="duplex"/>
  <kpi4me-checkbox-element [formControlElement]="form.controls.color" [data]="color"/>

  <div style="padding-top: 1rem">
    <div class="mat-h3 flex-column" style="text-align: left">
      <span> Adresse des Senders </span>

      <div class="mat-subtitle-2">Die Adresse, die als Absender auf dem Brief angegeben ist.</div>

      <mat-divider/>
    </div>

    <div class="form-field-wrapper">
      <kpi4me-text-element
        [formControlElement]="form.controls.senderName"
        [label]="'Absendername'"
      />

      <div class="two-elements">
        <span id="street">
          <kpi4me-text-element
            [formControlElement]="form.controls.senderStreet"
            [label]="'Straße '"
          />
        </span>

        <span>
          <kpi4me-text-element
            [formControlElement]="form.controls.senderHouseNumber"
            [inputType]="'text'"
            [label]="'Hausnummer '"
          />
        </span>
      </div>

      <div class="two-elements">
        <span id="postalcode">
          <kpi4me-text-element
            [formControlElement]="form.controls.senderPostCode"
            [inputType]="'text'"
            [label]="'PLZ '"
          />
        </span>

        <span>
          <kpi4me-text-element
            [formControlElement]="form.controls.senderCity"
            [inputType]="'text'"
            [label]="'Ort '"
          />
        </span>
      </div>
    </div>
  </div>

  <!--  <app-confirm-icon-button></app-confirm-icon-button>-->
  <div class="button-wrapper">
    <button [disabled]="!form.valid" mat-stroked-button [color]="'accent'" (click)="onRequestSms()">SMS Code Anfordern
    </button>
    <button mat-stroked-button [color]="'primary'" (click)="onHealthCheck()">System Check</button>
  </div>
</div>
